import axios from 'axios'
import React, { useEffect, useState } from 'react'
import * as TypIcons from 'react-icons/ti'
import { useParams } from 'react-router'
import { useNavigate } from 'react-router-dom'
import authService from '../../../../Components/Login/auth.service'
import {
  ContainerPage,
  TitleOfPage,
  TitlePage2
} from '../../../../Components/Main'
import SidebarMobile from '../../../../Components/SideBar-right/SidebarMobile'
import '../../../../styles/pages/SubMenuPages/SubMenuGruposUsuarios/pagesGruposDeUsuario/PermissoesDeAcessoAoSistema.css'

function PermissoesDeAcessoAoSistema() {
  const permissoesDesc = {
    ACECAD: 'Acesso aos dados cadastrais',
    ACELOC: 'Acesso ao cadastro de locais',
    ACEPES: 'Acesso ao cadastro de pessoas',
    ACEAUD: 'Acesso as auditorias',
    ACETXT: 'Acesso ao cadastro de textos',
    ACEUNI: 'Acesso ao cadastro de Unidade',
    ACEGPU: 'Acesso ao cadastro de grupo de usuários',
    ACEFUN: 'Acesso ao cadastro de funções',
    ACEREL: 'Acesso aos relatórios',
    ACETPD: 'Acesso aos cadastro de tipo de documentos',
    ACEDOC: 'Acesso aos cadastro de documentos'
  }
  let id = useParams<{ IdGrupoUsuario: string }>()
  const [searchTerm, setSearchTerm] = useState('')
  var user = authService.getCurrentUser()
  const history = useNavigate()
  let newDate = new Date()
  const [campos, setCampos] = useState({
    IdPermissao: 0,
    perAcesso: 0,
    perObservacoes: '',
    perAlteradoPor: user[0].pesEmail,
    perAlteradoEm: newDate
  })
  const [permissoes, setPermissoes] = useState<any[]>([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
          '/api/v1/permissao/list/' +
          id.IdGrupoUsuario
      )
      .then(response => {
        setPermissoes(response.data)
      })
  }, [])
  function handleUnidadeChange(event: any, permissao: any) {
    let status = 0
    if (event.target.checked) {
      status = 1
    }
    campos.perAcesso = status
    setCampos(campos)
    event.preventDefault()
    axios
      .put(
        process.env.REACT_APP_API_URL +
          '/api/v1/permissao/' +
          permissao.IdPermissao,
        campos
      )
      .then(response => {
        window.location.reload()
      })
  }
  return (
    <div className="displayInteract">
      <ContainerPage>
        <div id="containerHead1">
          <div className="logo" />
        </div>
        <button
          className="btnReturn"
          type="button"
          onClick={() => history(-1)}
        >
          <TypIcons.TiArrowBackOutline />
        </button>
        <div id="containerHead2">
          <TitleOfPage>
            <TitlePage2>Permissões de Acesso ao Sistema - Grupo</TitlePage2>
          </TitleOfPage>
          <div id="containerPesquisaModal">
            <input
              className="fnamePadrao"
              placeholder="Pesquisar"
              type="text"
              id="fname1"
              name="fname"
              onChange={event => {
                setSearchTerm(event.target.value)
              }}
            />
          </div>
        </div>
        <div className="tabelaPadrao">
          <table>
            <thead>
              <th>Permissão</th>
              <th>Módulo</th>
              <th>Descrição</th>
            </thead>
            <tbody>
              {permissoes
                .filter(val => {
                  if (searchTerm === '') {
                    return val
                  } else if (
                    val.perModulo
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  ) {
                    return val
                  }
                })
                .map(permissao => (
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        defaultChecked={!!permissao.perAcesso}
                        onChange={event => {
                          handleUnidadeChange(event, permissao)
                        }}
                      />
                    </td>
                    <td>{permissao.perModulo}</td>
                    <td>
                      <p className="Space">
                        {permissoesDesc[permissao.perModulo as keyof typeof permissoesDesc]}
                      </p>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </ContainerPage>
    </div>
  )
}

export default PermissoesDeAcessoAoSistema
